// extracted by mini-css-extract-plugin
export default {"productTile":"_2qG85dG","productLink":"_3TqU78D"};